import axios2 from '../api/axios';
export const supplierservices = {
    createsupplier,
    editsupplier,
    createmultisupplier,
    getbulkdata,
    deletesupplier,
    getManufacturer,
//     getsingleproduct,
    getallsupllier,
    // getDepartment,
    // createdesignation,
    // getDesignations    
    
}

function createsupplier(objdata){
    return axios2.post(`/createsupplier`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function editsupplier(objdata){
    return axios2.post(`/editsupplier`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

 function deletesupplier(id){
     return axios2.post(`/deletesupplier`,id,((response)=>{
          return response;   
     })).catch((error)=>{
          console.log(error); 
     })  
 }

function createmultisupplier(objdata){
    const formdata = new FormData();
    formdata.append('supplierfile',objdata); 
    return axios2.post(`/createmultisupplier`,formdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}


function getbulkdata(id='all',page,pageSize){
    return axios2.get(`/getbulkdata?id=${id}&page=${page}&limit=${pageSize}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}
function getsinglesupplier(id){
    return axios2.get(`/getsinglesupplier?id=${id}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}



function getManufacturer(id){
    return axios2.get(`/getManufacturer?id=${id}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })     
      
}
function getallsupllier(){
     return axios2.get(`/getallsupllier`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}